<template>
  <div data-v-548b72e6>
    <div data-v-548b72e6 class="row">
      <div data-v-548b72e6="" class="LeftPart el-col el-col-24">
        <div data-v-548b72e6="" class="el-card is-never-shadow">
          <div class="el-card__body" style="padding: 16px; text-align: left;">
            <div v-if="vfile!=1" data-v-548b72e6="" class="imgrow">
              <div v-for="vf in vfile" data-v-548b72e6="" class="Picture">
                <div data-v-548b72e6="" class="el-image imglist">
                  <el-image :src="vf" :preview-src-list="srcList" class="imglist">
                  </el-image>
                </div>
              </div>
            </div>
            <div v-if="vfile!=1" data-v-548b72e6="" class="G-title" style="margin-bottom: 5px;"></div>
            <div data-v-548b72e6="" class="InfoField">
              <div data-v-548b72e6="" class="InfoHead">
                <span data-v-548b72e6="" class="InfoTitle">{{ v.title }}</span>
                <div data-v-548b72e6=""> </div>
              </div>
              <div data-v-548b72e6="" class="text-secondary"><small data-v-548b72e6="" class="pr-2"><svg
                    data-v-73b7ef61="" data-v-548b72e6="" aria-hidden="true" class="svg-icon"
                    style="fill: rgb(153, 153, 153);">
                    <use data-v-73b7ef61="" xlink:href="#icon-time"></use>
                  </svg>
                  {{ v.create_time }}
                </small> <small data-v-548b72e6="" class="pr-2"><svg data-v-73b7ef61="" data-v-548b72e6=""
                    aria-hidden="true" class="svg-icon" style="fill: rgb(153, 153, 153);">
                    <use data-v-73b7ef61="" xlink:href="#icon-browse"></use>
                  </svg>
                  {{ v.browse }}
                </small> <small v-if="v.yinsi==1" data-v-548b72e6="" class="pr-2"><svg data-v-73b7ef61="" data-v-548b72e6=""
                    aria-hidden="true" class="svg-icon" style="fill: rgb(153, 153, 153);">
                    <use data-v-73b7ef61="" xlink:href="#icon-seeuser"></use>
                  </svg>
                  匿名
                </small>
                <small v-if="v.yinsi==0" data-v-548b72e6="" class="pr-2"><svg data-v-73b7ef61="" data-v-548b72e6=""
                    aria-hidden="true" class="svg-icon" style="fill: rgb(153, 153, 153);">
                    <use data-v-73b7ef61="" xlink:href="#icon-seeuser"></use>
                  </svg>
                  {{v.author}}
                </small>
                <small v-if="puids === 1" data-v-548b72e6="" class="pr-2" style="color:red" @click="showdel">删除</small>
                <small v-if="tops === 0 && puids === 1"data-v-548b72e6="" class="pr-2" style="color:red" @click="showtop">置顶</small>
                <small v-if="tops === 1 && puids === 1"data-v-548b72e6="" class="pr-2" style="color:red" @click="shownotop">取消置顶</small>
              </div>
              <div data-v-548b72e6="" class="Profiles">
                <div data-v-548b72e6="" class="Profile"><svg data-v-73b7ef61="" data-v-548b72e6="" aria-hidden="true"
                    class="svg-icon" style="fill: rgb(255, 51, 153);">
                    <use data-v-73b7ef61="" xlink:href="#icon-address"></use>
                  </svg> <span data-v-548b72e6="" style="color: rgb(255, 51, 153);">{{ v.dz }}</span></div>
              </div>
              <div data-v-548b72e6="" class="Profiles">
                <div data-v-548b72e6="" class="Profile"><span data-v-548b72e6="" class="font-weight-bold">小姐年龄：</span>
                  {{ v.age }}
                </div>
              </div>
              <div data-v-548b72e6="" class="Profiles">
                <div data-v-548b72e6="" class="Profile"><span data-v-548b72e6="" class="font-weight-bold">小姐颜值：</span>
                  {{ v.face_value }}
                </div>
              </div>
              <div data-v-548b72e6="" class="Profiles">
                <div data-v-548b72e6="" class="Profile"><span data-v-548b72e6="" class="font-weight-bold">消费水平：</span>
                  {{ v.price }}
                </div>
              </div>
              <div data-v-548b72e6="" class="Profiles">
                <div data-v-548b72e6="" class="Profile"><span data-v-548b72e6="" class="font-weight-bold">服务项目：</span>
                  {{ v.project }}
                </div>
              </div>
              <div data-v-548b72e6=""><button @click="dialogFormVisible=true" data-v-548b72e6="" type="button"
                  class="el-button el-button--default el-button--mini is-plain"><span><svg data-v-73b7ef61=""
                      data-v-548b72e6="" aria-hidden="true" class="svg-icon" style="fill: rgb(255, 51, 153);">
                      <use data-v-73b7ef61="" xlink:href="#icon-report"></use>
                    </svg>
                    我要举报
                  </span></button> <button @click="shoucang_submit" data-v-548b72e6="" type="button"
                  class="el-button el-button--default el-button--mini is-plain"><span><svg data-v-73b7ef61=""
                      data-v-548b72e6="" aria-hidden="true" class="svg-icon" style="fill: rgb(255, 51, 153);">
                      <use data-v-73b7ef61="" xlink:href="#icon-noheart"></use>
                    </svg>
                    {{shoucangname}}
                  </span></button> </div>
            </div>
          </div>
        </div>
        <div data-v-548b72e6="" class="el-card is-never-shadow">
          <div class="el-card__body" style="padding: 16px; text-align: left;">
            <div data-v-548b72e6="" style="text-align: center;"><svg data-v-73b7ef61="" data-v-548b72e6=""
                aria-hidden="true" class="svg-icon" style="fill: rgb(255, 51, 153); font-size: 40px;">
                <use data-v-73b7ef61="" xlink:href="#icon-warring"></use>
              </svg></div>
            <p data-v-548b72e6="">
              本站为信息分享平台，并不对寻欢经历负责，请注意个人防范。凡是有要求路费/上门/红包/定金/保证金/照片验证/视频验证/提前付费等类似行为的都是骗子，同时也请注意任何形式的推荐办卡行为、引导下载APP行为，请勿上当受骗。碰到有问题的信息，请及时举报给我们删除信息。如果发布的信息涉及个人隐私，也请及时举报，我们会核实后第一时间帮你删除处理。
            </p>
          </div>
        </div>
        <div v-if="userpuid === 4" data-v-548b72e6="" class="el-card is-never-shadow" style="user-select: auto;">
          <div class="el-card__body" style="padding: 16px; text-align: left;">
            <div data-v-548b72e6="" class="InfoField">
              <div data-v-548b72e6="" class="G-title"><span data-v-548b72e6=""><svg data-v-73b7ef61=""
                    data-v-548b72e6="" aria-hidden="true" class="svg-icon" style="margin-right: 5px;">
                    <use data-v-73b7ef61="" xlink:href="#icon-call"></use>
                  </svg>联系方式</span>
              </div>
              <div data-v-291d59e3="" class="Profiles">
                <div data-v-291d59e3="" class="Profile">
                  <span data-v-291d59e3="" class="g">QQ：</span> <span data-v-291d59e3="">{{ v.qq }}</span>
                </div>
              </div>
              <div data-v-291d59e3="" class="Profiles">
                <div data-v-291d59e3="" class="Profile">
                  <span data-v-291d59e3="" class="g">微信：</span> <span data-v-291d59e3="">{{ v.wechat }}</span>
                </div>
              </div>
              <div data-v-291d59e3="" class="Profiles">
                <div data-v-291d59e3="" class="Profile">
                  <span data-v-291d59e3="" class="g">电话：</span> <span data-v-291d59e3="">{{ v.phone }}</span>
                </div>
              </div>
              <div data-v-291d59e3="" class="Profiles">
                <div data-v-291d59e3="" class="Profile">
                  <span data-v-291d59e3="" class="g">地址：</span> <span data-v-291d59e3="">{{ v.address }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="userpuid === 3" data-v-548b72e6="" class="el-card is-never-shadow" style="user-select: auto;">
          <div class="el-card__body" style="padding: 16px; text-align: left;">
            <div data-v-548b72e6="" class="InfoField">
              <div data-v-548b72e6="" class="G-title"><span data-v-548b72e6=""><svg data-v-73b7ef61=""
                    data-v-548b72e6="" aria-hidden="true" class="svg-icon" style="margin-right: 5px;">
                    <use data-v-73b7ef61="" xlink:href="#icon-call"></use>
                  </svg>联系方式</span>
              </div>
              <div data-v-291d59e3="" class="Profiles">
                <div data-v-291d59e3="" class="Profile">
                  <span data-v-291d59e3="" class="g">QQ：</span> <span data-v-291d59e3="">{{ v.qq }}</span>
                </div>
              </div>
              <div data-v-291d59e3="" class="Profiles">
                <div data-v-291d59e3="" class="Profile">
                  <span data-v-291d59e3="" class="g">微信：</span> <span data-v-291d59e3="">{{ v.wechat }}</span>
                </div>
              </div>
              <div data-v-291d59e3="" class="Profiles">
                <div data-v-291d59e3="" class="Profile">
                  <span data-v-291d59e3="" class="g">电话：</span> <span data-v-291d59e3="">{{ v.phone }}</span>
                </div>
              </div>
              <div data-v-291d59e3="" class="Profiles">
                <div data-v-291d59e3="" class="Profile">
                  <span data-v-291d59e3="" class="g">地址：</span> <span data-v-291d59e3="">{{ v.address }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="userpuid === 2" data-v-548b72e6="" class="el-card is-never-shadow" style="user-select: auto;">
          <div class="el-card__body" style="padding: 16px; text-align: left;">
            <div data-v-548b72e6="" class="InfoField">
              <div data-v-548b72e6="" class="G-title"><span data-v-548b72e6=""><svg data-v-73b7ef61=""
                    data-v-548b72e6="" aria-hidden="true" class="svg-icon" style="margin-right: 5px;">
                    <use data-v-73b7ef61="" xlink:href="#icon-call"></use>
                  </svg>联系方式</span></div>
              <div data-v-548b72e6="">
                <div data-v-548b72e6="" style="padding-top: 5px;">
                  <p data-v-548b72e6="" style="font-size: 16px;">本信息将会扣除
                    <span data-v-548b72e6="" style="color: rgb(255, 51, 153); font-size: 16px;">20</span>
                    积分，你积分不足或者VIP已过期，你可以通过发布信息赚取积分或者升级VIP无限制查看联系方式。
                  </p>
                </div>
              </div>
              <div data-v-548b72e6="" class="Profiles">
                <div data-v-548b72e6="" class="Profile"> <a data-v-548b72e6="" href="/upgrade" class="navbar-nav"
                    style="color: rgb(255, 51, 153);"><button data-v-548b72e6="" type="button"
                      class="el-button el-button--default el-button--small"><span><span data-v-548b72e6=""
                          style="font-size: 14px;">升级VIP</span></span></button></a> <a data-v-548b72e6=""
                    href="/publish" class="navbar-nav" style="color: rgb(255, 51, 153);"><button data-v-548b72e6=""
                      type="button" class="el-button el-button--default el-button--small"><span><span data-v-548b72e6=""
                          style="font-size: 14px;">发布信息</span></span></button></a></div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="userpuid === 1" data-v-548b72e6="" class="el-card is-never-shadow" style="user-select: auto;">
          <div class="el-card__body" style="padding: 16px; text-align: left;">
            <div data-v-548b72e6="" class="InfoField">
              <div data-v-548b72e6="" class="G-title"><span data-v-548b72e6=""><svg data-v-73b7ef61=""
                    data-v-548b72e6="" aria-hidden="true" class="svg-icon" style="margin-right: 5px;">
                    <use data-v-73b7ef61="" xlink:href="#icon-call"></use>
                  </svg>联系方式</span></div>
              <div data-v-548b72e6="" style="padding-top: 5px;">
                <p data-v-548b72e6="" style="font-size: 16px;">您需要
                  <a data-v-548b72e6="" href="/login" class="" style="color: rgb(255, 51, 153); font-size: 16px;">登录</a>
                  才可继续查看联系方式
                </p><a href="/login"><button data-v-548b72e6="" type="button"
                  class="el-button el-button--default el-button--medium is-plain is-round"><span>立即登录</span></button></a>
                <p data-v-548b72e6="">* 普通用户查看需要扣除20积分，你可以发布信息赚取积分或者升级VIP会员无限制查看。</p>
              </div>
            </div>
          </div>
        </div>
        <div data-v-548b72e6="" class="el-card is-never-shadow">
          <div class="el-card__body" style="padding: 16px; text-align: left;">
            <div data-v-548b72e6="" class="InfoField">
              <div data-v-548b72e6="" class="G-title"><span data-v-548b72e6=""><svg data-v-73b7ef61=""
                    data-v-548b72e6="" aria-hidden="true" class="svg-icon" style="margin-right: 5px;">
                    <use data-v-73b7ef61="" xlink:href="#icon-sex"></use>
                  </svg>详情介绍</span></div>
              <div data-v-548b72e6="">
                <p data-v-548b72e6="" class="mb-2" style="white-space: pre-line !important;">{{ v.process }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-v-6ef9c908="" data-v-548b72e6="" class="RightPart el-col el-col-24">
        <div data-v-6ef9c908="" class="el-card is-hover-shadow" style="margin-top: 8px;">
          <div class="el-card__body" style="padding: 0px; height: 100px;">
            <div data-v-6ef9c908="" class="C-InfoCard">
              <div data-v-6ef9c908="" class="Content" style="margin-left: 10px;">
                <div data-v-6ef9c908="" class="Profile">
                  <div data-v-6ef9c908="" class="p4" style="color: rgb(255, 51, 153);">
                    * 特别提醒：请勿在联系对方时告诉对方信息来源！
                  </div>
                </div>
                <div data-v-6ef9c908="" class="Profiles"><a data-v-6ef9c908="" href="/help" class="navbar-nav"><button
                      data-v-6ef9c908="" type="button"
                      class="el-button el-button--default el-button--small is-plain"><span><svg data-v-73b7ef61=""
                          data-v-6ef9c908="" aria-hidden="true" class="svg-icon" style="fill: rgb(255, 51, 153);">
                          <use data-v-73b7ef61="" xlink:href="#icon-Identify"></use>
                        </svg> <span data-v-6ef9c908="" style="font-size: 14px;">鉴别指南</span></span></button></a> <a
                    data-v-6ef9c908="" href="/help" class="navbar-nav"><button data-v-6ef9c908="" type="button"
                      class="el-button el-button--default el-button--small is-plain"><span><svg data-v-73b7ef61=""
                          data-v-6ef9c908="" aria-hidden="true" class="svg-icon" style="fill: rgb(255, 51, 153);">
                          <use data-v-73b7ef61="" xlink:href="#icon-rule"></use>
                        </svg> <span data-v-6ef9c908="" style="font-size: 14px;">信息规则</span></span></button></a></div>
              </div>
            </div>
          </div>
        </div>
        <div data-v-6ef9c908="" class="G-title"><svg data-v-73b7ef61="" data-v-6ef9c908="" aria-hidden="true"
            class="svg-icon">
            <use data-v-73b7ef61="" xlink:href="#icon-address"></use>
          </svg>
          本地其他推荐</div>
        <a v-for="r in rdata" data-v-6ef9c908="" :href="'show?id=' + r.id" class="active">
          <div data-v-6ef9c908="" class="el-card is-hover-shadow" style="margin: 0.1rem !important;">
            <div class="el-card__body" style="padding: 0px; height: 160px;">
              <div data-v-6ef9c908="" class="C-InfoCard">
                <div data-v-6ef9c908="" class="Content">
                  <div data-v-6ef9c908="" class="Title">{{ r.title }}</div>
                  <div data-v-6ef9c908="">
                    <div data-v-6ef9c908="" class="State">
                      <div data-v-6ef9c908=""><svg data-v-73b7ef61="" data-v-6ef9c908="" aria-hidden="true"
                          class="svg-icon" style="fill: rgb(153, 153, 153);">
                          <use data-v-73b7ef61="" xlink:href="#icon-time"></use>
                        </svg> <span data-v-6ef9c908="">{{ r.create_time }}</span></div>
                      &nbsp;&nbsp;
                      <div data-v-6ef9c908=""><svg data-v-73b7ef61="" data-v-6ef9c908="" aria-hidden="true"
                          class="svg-icon" style="fill: rgb(153, 153, 153);">
                          <use data-v-73b7ef61="" xlink:href="#icon-browse"></use>
                        </svg> <span data-v-6ef9c908="">{{ r.browse }}</span></div>
                    </div>
                    <div data-v-6ef9c908="" class="Desc">{{ r.process }}</div>
                  </div>
                  <div data-v-6ef9c908="" class="Location">
                    <div data-v-6ef9c908="" class="Left"><svg data-v-73b7ef61="" data-v-6ef9c908="" aria-hidden="true"
                        class="svg-icon" style="fill: rgb(255, 51, 153);">
                        <use data-v-73b7ef61="" xlink:href="#icon-address"></use>
                      </svg> <span data-v-6ef9c908="">{{ r.dz }}</span></div>
                    <div data-v-6ef9c908="" class="Tags"> </div>
                  </div>
                </div> <img data-v-6ef9c908="" :src="r.img" onerror="this.remove()" class="Cover">
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <el-dialog title="我要举报" :visible.sync="dialogFormVisible" :lock-scroll="false">
      <el-form :model="jubaoform">
        <el-form-item label="举报信息：">
          <el-input v-model="jubaoform.title" disabled></el-input>
        </el-form-item>
        <el-form-item label="投诉类别：">
          <el-select v-model="jubaoform.lei" placeholder="请选择投诉类别" style="width: 100%;">
            <el-option v-for="l in jubaoformlei" :label="l.label" :value="l.value" :key="l.value"></el-option>
          </el-select>
          <div v-if="errorlei" class="el-form-item__error">请选择举报原因</div>
        </el-form-item>
        <el-form-item label="举报原因：">
          <el-input type="textarea" :rows="2" placeholder="请详细填写举报原因" v-model="jubaoform.yuanyin"></el-input>
          <div v-if="erroryuanyin" class="el-form-item__error">举报原因不能为空</div>
        </el-form-item>
        <br>
        <div data-v-548b72e6="" style="color: rgb(255, 51, 153); font-weight: bold;">审核成功后，内容将在24小时内删除。</div>
        <br>
        <div data-v-548b72e6="" style="color: rgb(255, 51, 153); font-weight: bold;">本站邮箱：hocwfsg@hotmail.com</div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button type="primary" @click="jubaoform_tj">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cookie from 'js-cookie'
export default {
  name: 'show',
  data() {
    return {
      v: [],
      vfile: [],
      srcList: [],
      rdata: [],

      userpuid: null,
      
      dialogFormVisible:false,
      jubaoform:{},
      jubaoformlei:[
        {label:'无效联系方式',value:1},
        {label:'虚假信息',value:2},
        {label:'提前付费',value:3},
        {label:'隐私侵犯',value:4},
        {label:'其他',value:5},
      ],
      errorlei:false,
      erroryuanyin:false,

      shoucangname:'我要收藏',

      tops:0,

      puids:null,
    }
  },
  methods:{
    shownotop(){

      let id = this.$route.query.id

      this.$http.post('/api/shownotop',{id:id}).then(res=>{

        if(res.data.code==1){

          this.$message({
            message: '取消置顶成功',
            type: 'success',
            onClose:()=>{
                window.location.href='show?id='+id;
            }
          });

        }
        
      })

    },
    showdel(){

      let id = this.$route.query.id

      this.$http.post('/api/showdel',{id:id}).then(res=>{

        if(res.data.code==1){

          this.$message({
            message: '删除成功',
            type: 'success',
            onClose:()=>{
                window.location.href='lists';
            }
          });

        }
        
      })

    },
    showtop(){

      let id = this.$route.query.id

      this.$http.post('/api/showtop',{id:id}).then(res=>{

        if(res.data.code==1){

          this.$message({
            message: '置顶成功',
            type: 'success',
            onClose:()=>{
                window.location.href='show?id='+id;
            }
          });

        }
        
      })

    },
    shoucang_submit(){

      let id = this.$route.query.id

      let sessionid = cookie.get('sessionid')

      if(sessionid){

        this.$http.post('/api/shoucang',{id:id}).then(res=>{
        
          if(res.data.code==1){

            this.shoucangname = '取消收藏';

          }else if(res.data.code==2){

            this.shoucangname = '我要收藏';

          }
          
        })

      }else{

        this.$message({
          message: '请先登录',
          type: 'error',
          onClose:()=>{
              window.location.href='login';
          }
        });

      }

    },
    jubaoform_tj(){

      if(!this.jubaoform.lei){
        this.errorlei = true
      }else{
        this.errorlei = false
        if(!this.jubaoform.yuanyin){
          this.erroryuanyin = true
        }else{
          this.erroryuanyin = false
          //信息id
          let ids = this.$route.query.id
          //可以提交保存到数据库了
          this.$http.post('/api/report',{id:ids,lei:this.jubaoform.lei,msg:this.jubaoform.yuanyin}).then(res=>{
            if(res.data.code==1){

              this.$message({
                message: '举报成功',
                type: 'success'
              });

              setTimeout(()=>{

                window.location.href = 'show?id='+res.data.tid

              },3000)

            }else if(res.data.code==2){

              this.$message({
                message: '你已经举报过了，无需重复举报。',
                type: 'warning'
              });

              setTimeout(()=>{

                window.location.href = 'show?id='+res.data.tid

              },3000)

            }else if(res.data.code==3){

              this.$message({
                message: '请先登录',
                type: 'error'
              });

              setTimeout(()=>{

                window.location.href = 'login'

              },3000)

            }
          })
        }
      }

    }
  },
  mounted() {

    let ids = this.$route.query.id

    this.$http.post('/api/show', { id: ids }).then(res => {

      if(res.data.v){

        this.v = res.data.v

        if(res.data.v.shoucang==0){

          this.shoucangname = '我要收藏'

        }else if(res.data.v.shoucang==1){

          this.shoucangname = '取消收藏'

        }

        if(res.data.v.file){

          this.vfile = JSON.parse(res.data.v.file)

          this.srcList = JSON.parse(res.data.v.file)

        }else{

          this.vfile = 1

          this.srcList = 1

        }

        this.rdata = res.data.rdata

        this.userpuid = res.data.v.type

        this.puids = res.data.v.uid

        //我要举报 标题
        this.jubaoform.title = res.data.v.title

        this.tops = res.data.v.top

        console.log(this.puids)

      }else{

        this.$message({
          message: '信息不存在',
          type: 'error',
          onClose:()=>{
              window.location.href='lists';
          }
        });

      }

    })

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/show.vue